<template>
  <v-app style="height: 100%;">
    
    <v-col align="start" style="width: 100%; display: flex; flex-flow: column; height: 100%; position: fixed " md="12" lg="12" xl="12" cols="12" class="my-0 py-0 py-0 my-0 ml-0 pl-0" v-if="!$store.getters.islogo && colorsReady">
      <v-row justify="center" style="overflow-y:auto; margin: 0 auto; overflow-y: scroll; overflow-x: hidden; width: 100vw; flex-grow : 1; display: block; scrollbar-width: none; height: 99%" class="pb-0 pl-0 ml-0 caliz">
        <router-view ></router-view> 
      </v-row>
    </v-col>
    
    <v-snackbar v-model="this.$store.state.alertState" class="font" style="z-index: 80;" :timeout="10000" :top="true" :app="true" :elevation="24" :color="this.$store.state.alertColor">
              {{ this.$store.state.alertMessage }}
        </v-snackbar>
    <transition name="fade" mode="in-out"> 
      <v-col align-self="start" id="container" style="width: 100%; display: flex; flex-flow: column; height: 99%; position: fixed " md="12" lg="12" xl="12" cols="12" class="my-0 py-0 px-0 mx-0" v-if="$store.getters.islogo && colorsReady">
        
        <v-row v-show="true" style="margin: 0 auto; width: 100%; max-height: 60px;" id="header" class="px-0 py-0 my-0">
          <NewHeader>
          </NewHeader>
        </v-row>

        <v-row class="caliz" style=" overflow-y:auto; margin: 0 auto; overflow-y: scroll; overflow-x: hidden; width: 100%; flex-grow : 1; display: block; scrollbar-width: none; height: 50%">
            <router-view  class="px-0"></router-view>
        </v-row>

        <v-row style="margin: 0 auto; width: 100%; max-height: 53px;" v-if="$store.getters.isHideFooter && !$store.state.validationDelivery" class="px-0 py-0 my-0" id="footer">
          <NewFooter class="px-0" v-if="!$store.getters.isdetails">
          </NewFooter>
          <NewFooterDetails class="px-0" v-else>
          </NewFooterDetails>
        </v-row>
      </v-col>
    </transition>
  </v-app>
  
</template>


<script>
// import NewDetails from './components/NewDetails.vue';
import NewHeader from './components/immutable/NewHeader.vue';
import NewFooter from './components/immutable/NewFooter.vue';
import NewFooterDetails from './components/immutable/NewFooterDetails.vue';

export default {
  name: 'App',

  components: {
    // NewDetails,
    NewHeader,
    NewFooter,
    NewFooterDetails
  },
  
  data () {
    return {
      colorsReady: false,
      drawer: true,
      v:true,
      windowSize: {
          x: 0,
          y: 0,
      },
      containerHeight: null,
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
        this.handleResize();
    // setTimeout(function(){ this.$router.push({ name: 'menu'}); }, 2500);
    
  },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowSize.x = window.innerWidth;
            this.windowSize.y = window.innerHeight;
            // console.log("HIDEN:", this.$route.name)
            if(this.$route.name != "menu" && this.$route.name != "details")
              this.containerHeight = this.windowSize.y - 60;
            else
              this.containerHeight = this.windowSize.y - 130;
        }
    },
    created() {
      // console.log("HIDEN:", this.$store.getters.isHideFooter)
      this.windowSize.y = window.innerHeight;
      if(this.$route.name != "menu" && this.$route.name != "details")
        this.containerHeight = this.windowSize.y - 60;
      else
        this.containerHeight = this.windowSize.y - 130;
      if(this.$router.currentRoute.name == 'loginDeliveryMan' || this.$router.currentRoute.name == 'orders_delivery_man'  || this.$router.currentRoute.name == 'orders_detail_delivery')
      {
        this.$store.state.colors.primary = "#FF4030"
        this.$store.state.colors.secondary = "#FFFFFF"
        this.$store.state.colors.accent = "#F2F2F2"
        this.colorsReady = true;
        console.log(this.$store.state.logo , this.colorsReady)
      }
    },
    watch:{
      $route: function(to){
          // console.log(to);
          if(this.$route.query.id!=this.$store.state.codigo_marca)
          {
            console.log("");         

          }
          if(to.name != "menu" && to.name != "details")
              this.containerHeight = this.windowSize.y - 60;
            else
              this.containerHeight = this.windowSize.y - 130;
      }
    }, 
    beforeCreate() {
      if(this.$route.query.id) 
      {
        if(this.$route.query.id!=this.$store.state.codigo_marca)
        {
          // console.log("EXIT");
          this.$store.state.lista_platillos = []; 
          this.$store.dispatch('initilizePedido')
          this.$store.state.validationDelivery=false;

          localStorage.removeItem('original_id_sucursal'); 
          localStorage.removeItem('sucursalData'); 
          localStorage.removeItem('metodo_envio'); 
          localStorage.removeItem('comentarios'); 
          localStorage.removeItem('token'); 
          localStorage.removeItem('userCards'); 
          this.$store.state.token = null; 
          this.$store.state.logo = false;
          localStorage.removeItem('id_cliente'); 
          this.$store.state.id_cliente = null; 
          localStorage.removeItem('id_sucursal'); 
          this.$store.state.id_sucursal = null; 
          localStorage.removeItem('nombre_cliente');
          localStorage.removeItem('addressUser'); 
          this.$store.state.nombre_cliente = null; 
          localStorage.removeItem('tokenDM'); 
          this.$store.state.tokenDM = null;           
        }
        console.log(this.$route.query.id);
        this.$store.state.codigo_marca = this.$route.query.id;
        localStorage.setItem("codigo_marca",this.$route.query.id);
        // console.log(this.$store.state.codigo_marca);
        // console.log('entra');
      }
      
      if(this.$router.currentRoute.name == 'loginDeliveryMan' || this.$router.currentRoute.name == 'orders_delivery_man'  || this.$router.currentRoute.name == 'orders_detail_delivery')
      {
        this.$store.state.colors.primary = "#FF4030"
        this.$store.state.colors.secondary = "#FFFFFF"
        this.$store.state.colors.accent = "#F2F2F2"
        this.$store.state.backImage = null;
        this.$store.state.logo = false;
        this.colorsReady = true;
        // console.log(this.$store.state.logo , this.colorsReady)
      }
      else
      {
        this.$store.state.validationDelivery = false;
        var username = 'swyt1';
        var password = 'r3stoDirec0.y';
        var basicAuth = 'Basic ' + btoa(username + ':' + password);
        if(this.$store.state.codigo_marca)
        {
          this.$store.dispatch("GET", {url: 'datos_marca/' + this.$store.state.codigo_marca, headers: { 'Content-Type': 'application/json', 'Authorization': basicAuth}})
          .then(response => {
            this.$store.state.colors.primary = response.data[0].color_primario;
            this.$store.state.colors.secondary = response.data[0].color_secundario;
            this.$store.state.colors.accent = response.data[0].color_acento;
            this.$store.state.logoSRC = response.data[0].logotipo;
            this.$store.state.backImage = response.data[0].fondo_splash;
            this.colorsReady = true;
            // console.log(`%cRESPONSE`, 'color: green; font-weight: bold;', response);
          })
          .catch(error => {
            console.log(`%cERROR`, 'color: red; font-weight: bold;', error);
          });
        }
      }
      if(this.$router.currentRoute.name == 'logo' || this.$router.currentRoute.name == 'verification' || this.$router.currentRoute.name == 'registerStep1' || this.$router.currentRoute.name == 'registerStep2' || this.$router.currentRoute.name == 'ordersDeliveryMan' || this.$router.currentRoute.name == 'ordersDetailDelivery' || this.$router.currentRoute.name == 'restorePassword')
      {
        // console.log("PATH is Logo");
        this.$store.state.logo = false;
      }
      
      // console.log("Other than logo");
      // console.log(this.$store.getters.islogo);
      if(this.$router.currentRoute.name == 'details'){
        this.$store.state.details = true;
      }else{
        this.$store.state.details = false;
      }
      // console.log(this.$store.getters.isdetails);
    }
};
</script>
<style>
  
  html{
      overflow-y: hidden;
      overflow-x: hidden;
      scroll-behavior: smooth;
      height: 100%;
    }

    body {
      height: 100%;
      scrollbar-width: none;
    }

  .hidscroll {
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none;
  }
  /* width */
  ::-webkit-scrollbar {
    width: 0px;
    height: 2px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }


  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(100px);
    opacity: 0;
  }


  @font-face {
    font-family: 'Resto_Bold';
    src: url('./assets/fonts/RobotoSlab-Bold.ttf'); /* IE9 Compat Modes */
  }

  .RestoBold{
      font-family: 'Resto_Bold';
  }

  @font-face {
    font-family: 'Resto_Light';
    src: url('./assets/fonts/RobotoSlab-Light.ttf'); /* IE9 Compat Modes */
  }

  .RestoLight{
      font-family: 'Resto_Light';
  }

  @font-face {
    font-family: 'Resto_Regular';
    src: url('./assets/fonts/RobotoSlab-Regular.ttf'); /* IE9 Compat Modes */
  }

  .RestoRegular{
      font-family: 'Resto_Regular';
  }

  @font-face {
    font-family: 'Resto_Thin';
    src: url('./assets/fonts/RobotoSlab-Thin.ttf'); /* IE9 Compat Modes */
  }

  .RestoThin{
      font-family: 'Resto_Thin';
  }

  .buttonLower{
      text-transform: none !important;
  }

  @media screen and (max-width: 480px) {
      .caliz {
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;
      }
  }
</style>
